// internalUsers.js -- supports ?role=admin and ?impersonate=<uid>